(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AttivitaDialogController', AttivitaDialogController);

    AttivitaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Attivita'];

    function AttivitaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Attivita) {
        var vm = this;

        vm.attivita = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.attivita.id !== null) {
                Attivita.update(vm.attivita, onSaveSuccess, onSaveError);
            } else {
                Attivita.save(vm.attivita, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:attivitaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
